import React, { useEffect, useRef, useState } from "react";
import { getDownloadURL, ref, uploadBytes } from "firebase/storage"
import { db, storage } from "../../firebase/config"

const ChatTextInput = ({
	divClassName = "",
	inputClassName = "",
	defaultType = "text",
	defaultValue = "",
	onClick = undefined,
	sendImage = undefined,
	...props
}) => {
	const [type, setType] = useState(props.type)
	const [value, setValue] = useState(null)
	const inputRef = useRef(null)
	const fileRef = useRef(null);

	const handleAttachmentClick = () => {
		fileRef.current?.click();
	};

	const handleFileChange = async (e) => {
		const file = e.target.files?.[0];
		if (!file) return;

		try {
			// 1) Get base name + extension
			const original = file.name; // e.g. "my photo.png"
			const dot = original.lastIndexOf(".");
			const base = dot > -1 ? original.slice(0, dot) : original;
			const ext = dot > -1 ? original.slice(dot + 1) : ""; // "png"

			// 2) Sanitize base (no spaces/specials) and trim length
			const safeBase = base.toLowerCase().replace(/[^a-z0-9-_]+/g, "-").slice(0, 50);

			// 3) Timestamp (or use crypto.randomUUID())
			const ts = Date.now(); // e.g. 1731171234567

			// 4) Final filename with extension preserved
			const filename = ext ? `${safeBase}-${ts}.${ext}` : `${safeBase}-${ts}`;

			// 5) Optional: nest by user/chat if you have IDs
			// const path = `images/chat/${chatId}/${filename}`;
			const path = `images/chat/${filename}`;

			const storageRef = ref(storage, path);

			await uploadBytes(storageRef, file, { contentType: file.type });
			const imageURL = await getDownloadURL(storageRef);

			// setValue(imageURL);
			console.log("imageURL", imageURL);

			// Call the callback and pass the URL if you want
			sendImage(imageURL);
		} catch (err) {
			console.error("Upload failed:", err);
		} finally {
			// allow re-selecting the same file later
			e.target.value = "";
		}
	};



	useEffect(() => {
		if (props.onChange) {
			props.onChange(value)
		}
	}, [value])

	useEffect(() => {
		setValue(defaultValue)
	}, [defaultValue])

	useEffect(() => {
		setType(defaultType)
	}, [defaultType])

	const toggleType = () => {
		if (type === "password")
			setType('text')

		if (type === "text")
			setType('password')
	}

	const openCalendar = () => {
		inputRef.current.focus()

		setTimeout(() => {
			inputRef.current.click()
		}, 100);
	}

	const handleMouseWheel = (e) => {
		const inputElement = inputRef.current;

		const handleWheel = (e) => {
			e.preventDefault();
		};

		// Add the wheel event listener with passive: false
		inputElement.addEventListener('wheel', handleWheel, { passive: false });

		// Cleanup function to remove the event listener
		return () => {
			inputElement.removeEventListener('wheel', handleWheel);
		};
	}

	return (
		<div
			className={`w-full flex items-center justify-between border-[1px] border-gray text-xs rounded-[6px] ${divClassName}`}
		>
			<input
				ref={fileRef}
				type="file"
				accept="image/*"
				className="hidden"
				onChange={handleFileChange}
			/>

			<div className="bg-primary p-4 hover:bg-white transition cursor-pointer" onClick={handleAttachmentClick}>
				<img src="/assets/icons/icon-attachment.svg" alt="attachement" />
			</div>

			<input
				className={`!bg-transparent text-white p-4 px-6 w-full placeholder:text-white ${inputClassName}`}
				value={value}
				{...props}
				type={type}
				onChange={(e) => setValue(e.currentTarget.value)}
				ref={inputRef}
				onWheel={handleMouseWheel}
			/>

			<div className="bg-primary p-4 hover:bg-white transition cursor-pointer" onClick={onClick}>
				<img src="/assets/icons/arrow-upward.svg" alt="arrow-top" />
			</div>

		</div >
	)
};

export default ChatTextInput;
